import CandidateCardWrapper from './CandidateCardWrapper.component';

export default CandidateCardWrapper;
